<template>
  <div class="vh-100 bg-grey">
    <!-- HEADER -->
    <div class="header-top bg-white">

      <!-- Normal Header -->
      <div class="fixed-judul fixed-top">
        <div class="row justify-content-center align-items-center set-row w-limit">
          <div class="col-md-2 col-sm-2 col-2 remove-padding">
            <div @click="RouteToDashboard">
              <div class="header-icon icon-arrow-left"></div>
            </div>
          </div>
          <div class="col-md-8 col-sm-8 col-8 text-center remove-padding">
            <h6 class="remove-margin font-16 font-colorcheck text-promo nomore">
              Status SnapClean
            </h6>
          </div>
          <div data-v-8dbe3aee="" class="col-md-2 col-sm-2 col-2"></div>
        </div>
      </div>
    </div>

    <!-- MAIN NORMAL CONTENT -->
    <main class="page-wrapper main-page w-limit">
      <div>
        <div class="main-content-data">
          <a class="f-16 f-semi f-c-blue dropdown-toggle" href="#" data-toggle="dropdown">
            {{ status_text_snap }}
          </a>
          <div class="dropdown-menu mod">
            <a id="onlineSelect" class="dropdown-item" @click="mesinOnlineFunction">Online</a>
            <a id="offlineSelect" class="dropdown-item" @click="mesinOfflineFunction">Offline</a>
            <a id="runningSelect" class="dropdown-item" @click="mesinRunningFunction">Sedang Berjalan</a>
          </div>

          <div class="main-content">
            <div class="f-bold f-16 m-t-10">{{ jumlah_mesin }} Mesin</div>
            <div class="f-14 f-c-midgrey m-t-6">{{ wordingStatus }}</div>
            <div class="list-card">
              <div class="flex-1">
                <div class="set-card set-card-height" v-for="each in dataListMesinOutlet" :key="each.id"
                     @click="toListMesin(each.idoutlet)">
                  <div class="row add-padding-default">
                    <div class="col-md-3 col-sm-3 col-3  remove-margin remove-padding">
                      <figure class="box">
                        <img v-if="each.logo != ''" v-bind:src="each.logo" alt=""
                             style="width: 48px;border: 1px solid #E1E5EC;box-sizing: border-box;border-radius: 3px;">
                        <img v-else src="../../assets/gambar/Rectangle43.svg" alt=""
                             style="width: 48px;border: 1px solid #E1E5EC;box-sizing: border-box;border-radius: 3px;">
                      </figure>
                    </div>
                    <div class="col-md-8 col-sm-8 col-8  remove-padding">
                      <div class="font-16 remove-margin font-weight-bold nomore">
                        {{ each.nama_outlet }}
                      </div>
                      <div class="font-16 remove-margin nomore">
                        {{ each.jumlah_mesin }} {{ status_text_snap }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="loader"></div>
      </div>
    </main>
  </div>
</template>
<script>
export default {
  name: "ListKasLaci",
  data() {
    return {
      dataListMesinOutlet: [],
      jumlah_mesin: 0,
      statusSnap: "",
      status_snap: "",
      status_text_snap: "",
      wordingStatus: "-",
      requestHeaders: {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('token'),
        }
      },
    }
  },
  mounted() {
    this.mesinRunningFunction()
    $(".loader").hide()
  },
  methods: {
    toTop() {
      window.scrollTo(0, 0)
    },
    RouteToDashboard() {
      this.$emit("ToChildDashboard")
    },
    mesinOfflineFunction() {
      $(".main-content").hide()
      this.wordingStatus = "Mesin yang tidak bisa terhubung ke server."
      this.status_text_snap = "Offline"
      this.getDataListStatusMesinSnap("offline")
      $(".dropdown-item").removeClass("active")
      $("#offlineSelect").addClass("active")
    },
    mesinOnlineFunction() {
      $(".main-content").hide()
      this.wordingStatus = "Semua mesin yang terhubung ke server, termasuk mesin yang sedang berjalan."
      this.status_text_snap = "Online"
      this.getDataListStatusMesinSnap("online")
      $(".dropdown-item").removeClass("active")
      $("#onlineSelect").addClass("active")
    },
    mesinRunningFunction() {
      $(".main-content").hide()
      this.wordingStatus = "Mesin yang saat ini sedang digunakan atau dioperasikan."
      this.status_text_snap = "Sedang Berjalan"
      this.getDataListStatusMesinSnap("running")
      $(".dropdown-item").removeClass("active")
      $("#runningSelect").addClass("active")
    },
    async getDataListStatusMesinSnap(params) {
      $(".loader").show()
      try {
        const response = await this.$axios.get(this.$baseurl + '/masterData/meta/list_snap_perstatus?status=' + params, this.requestHeaders);
        if (response.data.code === 200) {
          if (response.data.status === true) {
            this.dataListMesinOutlet = []
            this.jumlah_mesin = response.data.data.total_semua_outlet
            var resultDataArray = Object.entries(response.data.data.data_peroutlet)
            for (var x = 0; x < resultDataArray.length; x++) {
              var jumlah_mesin = resultDataArray[x][1].total
              if (jumlah_mesin > 0) {
                var nama_outlet = resultDataArray[x][1].outlet.nama
                var idoutlet = resultDataArray[x][1].outlet.idoutlet
                var status = resultDataArray[x][1].status
                var urlSrcLogo
                if (resultDataArray[x][1].outlet.logo_url !== "" && resultDataArray[x][1].outlet.logo_url !== null) {
                  if (resultDataArray[x][1].outlet.logo_url.includes('bos_revamp/')) {
                    urlSrcLogo = "https://storage.googleapis.com/ember-e-dalbo/" + resultDataArray[x][1].outlet.logo_url
                  } else {
                    urlSrcLogo = "https://res.cloudinary.com/sinadme/c_scale,h_200/" + resultDataArray[x][1].outlet.logo_url
                  }
                } else {
                  urlSrcLogo = ""
                }
                var logo = urlSrcLogo
                this.dataListMesinOutlet.push({
                  "id": x,
                  "idoutlet": idoutlet,
                  "nama_outlet": nama_outlet,
                  "jumlah_mesin": jumlah_mesin,
                  "status": status,
                  "logo": logo,
                })
              }
            }
            $(".main-content").show()
          } else {
            this.popupType = "error";
            this.popupMessage = response.data.msg;
          }
        } else {
          this.popupType = "error";
          this.popupMessage = response.data.msg;
        }
      } catch (e) {
        if (!e.code) {
          this.popupType = "error";
          this.popupErrorException = e;
        }
      }
      $(".loader").hide()
    },
    toListMesin(idoutlet) {
      this.$router.push({
        name: "ListSnapMesin",
        query: {
          idoutlet: idoutlet
        }
      })
    }
  }
}
</script>
<style scoped>
.header-icon {
  height: 25px;
  width: 25px;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}

.main-content-data {
  padding: 20px 20px;
}

.set-card-height {
  height: 80px;
}

.list-card {
  margin-top: 15px;
}

</style>
<style>
.loader {
  -webkit-animation: spin 1s linear infinite;
  animation: spin 1s linear infinite;
  border: 3px solid #ddd;
  border-top: 3px solid #aeb0b0;
  border-radius: 50%;
  height: 50px;
  width: 50px;
  margin: 30% auto;
}

@-webkit-keyframes spin {
  to {
    border-top-color: #aeb0b0;
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes spin {
  to {
    border-top-color: #aeb0b0;
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>